module.exports = __webpack_public_path__ + "static/image/history/pc/202312.jpg?b213758f";